import React from "react";
import { useNavigate } from "react-router-dom";
import "./Footer.css";
import logoimage from "../../images/LogoMainSection.png";
import { GiGalaxy } from "react-icons/gi";

const Footer = () => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate("/LogIn");
  };
  const handleRedirect = () => {
    navigate("/contact-us");
  };
  const handleHomeRedirect = () => {
    navigate("/");
  };
  const handlePorpertyRedirect = () => {
    navigate("/Property");
  };

  return (
    <footer className="footer">
      <div className="container">
        <div className="row">
          {/* Logo and Address Section */}
          <div className="col-lg-3 col-md-6 mb-4 text-center text-lg-start">
            <div className="logo">
              <img src={logoimage} alt="" />
              <h3>REAL-ESTATE</h3>
            </div>
            <p> Kosovo, Rr.Tirana, Icon Tower, Prishtina 10000,</p>
          </div>

          {/* About Company Section */}
          <div className="col-lg-3 col-md-6 mb-4">
            <div className="h6p">
              <h6>Rreth Kompanisë</h6>
              <p>
                Ekipi ynë, në zemër të qytetit, ofron shërbim të personalizuar
                për çdo nevojë.
              </p>
            </div>
            <a href="/about" className="btn btn-footer">
              Na Kontaktoni
            </a>
            <a onClick={handleRedirect} className="btn btn-footer">
              +38348282262
            </a>
          </div>

          {/* Help Us Section */}
          <div className="col-lg-3 col-md-6 mb-4" id="links">
            <h6>Na Ndihmoni</h6>
            <ul className="list-unstyled">
              <li>
                <a onClick={handleHomeRedirect}>Home</a>
              </li>
              <li>
                <a href="/about">Rreth Nesh</a>
              </li>
              <li>
                <a onClick={handlePorpertyRedirect}>Shërbimet</a>
              </li>
              <li>
                <a href="/team">Ekipi</a>
              </li>
              <li>
                <a onClick={handleRedirect}>Info Shtesë</a>
              </li>
              <li>
                <a onClick={handleRedirect}>Kontakoni</a>
              </li>
            </ul>
          </div>

          {/* Log In Section */}
        </div>
        <div className="text-end text-lg-end">
          {/* <h6>Log In</h6>
            <button onClick={handleClick} className="btn btn-warning btn-sm">
              Login
            </button> */}
          <p className="mt-2">
            Website Created By Glaxio <GiGalaxy />.
            
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
